module.exports = __webpack_public_path__ + "static/img/app-logo.53f2dfe6.png";